










import { Component, Vue, Prop } from 'vue-property-decorator'

type OptionItemType = {
  id: string
  image?: string
  value: string
  name: string
}

@Component({})
export default class ConfirmAnswer extends Vue {
  @Prop({ required: true, default: '' }) private value!:
    | string
    | string[]
    | File[]
    | null

  @Prop({ required: false, default: [] }) private options!: OptionItemType[]
  @Prop({ required: true, default: 'text' }) private questionCategory!: string
  @Prop({ required: true, default: false }) private isText!: boolean

  private get confirmValues() {
    if (!this.value) return [{ value: '回答なし' }]
    if (['image'].includes(this.questionCategory)) {
      if (!Array.isArray(this.value)) return [{ text: '回答がありません' }]
      const uploadUrl: { image: string }[] = []
      ;(this.value as File[]).forEach((v: File) => {
        const blob = new Blob([v], { type: (v as File).type })
        uploadUrl.push({ image: URL.createObjectURL(blob) })
      })
      return uploadUrl
    }
    if (typeof this.value === 'string' && !this.options?.length) {
      return [{ value: this.value }]
    }
    if (typeof this.value === 'string') {
      const data = this.options.find(v => v.value === this.value)
      if (!data) return [{ value: '回答なし' }]
      return [
        {
          value: data.name,
          image: data.image
        }
      ]
    }
    const datas = (this.value as string[]).reduce<
      Array<{ value: string; image?: string }>
    >((prev, cur) => {
      const data = this.options.find(v => v.value === cur)
      if (!data) return prev
      prev.push({
        value: data.name,
        image: data.image
      })
      return prev
    }, [])
    if (!datas.length) return [{ value: '回答なし' }]
    return datas
  }
}
